import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiPlus } from 'react-icons/fi';
import { toast } from 'react-toastify';
import TemplateList from '../../components/Templates/TemplateList';
import templateService from '../../services/templateService';

const Templates = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({});

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async (appliedFilters = {}) => {
    setLoading(true);
    try {
      const data = await templateService.getAllTemplates(appliedFilters);
      setTemplates(data.templates || []);
      setFilters(appliedFilters);
    } catch (error) {
      console.error('Error loading templates:', error);
      toast.error('Failed to load templates');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await templateService.deleteTemplate(id);
      toast.success('Template deleted successfully');
      loadData(filters);
    } catch (error) {
      console.error('Error deleting template:', error);
      toast.error(error.response?.data?.error || 'Failed to delete template');
    }
  };

  const handleDuplicate = async (id) => {
    try {
      await templateService.duplicateTemplate(id);
      toast.success('Template duplicated successfully');
      loadData(filters);
    } catch (error) {
      console.error('Error duplicating template:', error);
      toast.error(error.response?.data?.error || 'Failed to duplicate template');
    }
  };

  const handleRefresh = (newFilters) => {
    loadData(newFilters);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-500">Loading templates...</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Templates</h1>
          <p className="text-gray-600 mt-1">Manage reusable templates for projects, tasks, and more</p>
        </div>
        <Link
          to="/app/templates/new"
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <FiPlus className="mr-2" />
          New Template
        </Link>
      </div>

      <TemplateList
        templates={templates}
        onDelete={handleDelete}
        onDuplicate={handleDuplicate}
        onRefresh={handleRefresh}
      />
    </div>
  );
};

export default Templates;

